export const selectTotalInvoiceCountSelector = (state) => {
    const { receiptedInvoiceCount, notReceiptedInvoiceCount } = state.stockReceipt;
    return receiptedInvoiceCount !== undefined && notReceiptedInvoiceCount !== undefined
        ? receiptedInvoiceCount + notReceiptedInvoiceCount
        : undefined;
};
